// src/services/contractService.js
import api from './api';

const contractService = {
  // ── Artist endpoints ───────────────────────────────────────────────────────

  /** Get all contracts for the authenticated artist. Optional status filter. */
  getMyContractsArtist: (status) =>
    api.get('/artists/contracts/my-contracts', {
      params: status ? { status } : {},
    }),

  /** Submit a new management contract request to a manager. */
  requestContract: (adminId, durationMonths, termsAgreed = true) =>
    api.post('/artists/contracts/request', {
      admin_id: adminId,
      duration_months: durationMonths,
      terms_agreed: termsAgreed,
    }),

  /** Artist withdraws a pending contract request (status → cancelled). */
  cancelContractRequest: (contractId) =>
    api.put(`/artists/contracts/${contractId}/cancel`),

  /** Artist terminates an active contract (status → terminated). */
  terminateContractArtist: (contractId) =>
    api.put(`/artists/contracts/${contractId}/terminate`),

  // ── Manager endpoints ──────────────────────────────────────────────────────

  /** Get all contracts for the authenticated manager. Optional status filter. */
  getManagerContracts: (status) =>
    api.get('/manager/contracts', {
      params: status ? { status } : {},
    }),

  /** Manager approves a pending contract request. */
  approveContract: (contractId) =>
    api.put(`/manager/contracts/${contractId}/approve`),

  /** Manager rejects a pending contract request. */
  rejectContract: (contractId) =>
    api.put(`/manager/contracts/${contractId}/reject`),

  /** Manager terminates an active contract. */
  terminateContractManager: (contractId) =>
    api.put(`/manager/contracts/${contractId}/terminate`),

  // ── Shared ─────────────────────────────────────────────────────────────────

  /** Get list of all available managers (for artist request-contract form). */
  getAvailableManagers: () =>
    api.get('/manager/managers'),

  /** Get list of artists currently managed by the authenticated manager. */
  getMyManagedArtists: () =>
    api.get('/manager/my-artists'),

  /** Dashboard aggregates for authenticated manager. */
  getManagerDashboardStats: () =>
    api.get('/manager/dashboard-stats'),
};

export default contractService;
